import { connection } from '@/api/connection'

export default {
  getLogo: () => connection.get('system/logo', { responseType: 'blob' })
}
